import { Component, Input, OnInit, Output } from '@angular/core';
import {
  INote,
  INoteDetail,
  IPaginatedResponse,
} from '@boma/supplier-portal/shared/entities';
import { NotesService } from '@boma/supplier-portal/shared/services';

@Component({
  selector: 'boma-note-list-component',
  templateUrl: './note-list-component.component.html',
  styleUrls: ['./note-list-component.component.scss'],
})
export class NoteListComponentComponent implements OnInit {
  @Input() notableId; // Have to pass in the GUID you want to link note to
  @Input() entityId;
  @Input() showTitle = true;

  notes: IPaginatedResponse<INoteDetail>;

  selectedImageURL = null;
  imageLoading = false;
  displayImageModal = false;
  loadedImages: string[] = [];

  currentPage = 1;
  pageSize = 25;

  constructor(private notesService: NotesService) {}

  ngOnInit(): void {
    this.getNotes();
  }

  getNotes(page = 1) {
    this.notesService
      .loadEntityNotes(
        this.entityId,
        [this.notableId],
        this.currentPage,
        this.pageSize
      )
      .subscribe((x) => {
        //todo add the pagination
        this.notes = x;
      });
  }

  refreshNotes() {
    this.currentPage = 1;
    this.getNotes();
  }

  loadPage(page) {
    if (this.currentPage != page) this.currentPage = page;
    this.getNotes();
  }

  updatePageSize(size) {
    this.pageSize = size;
    this.currentPage = 1;
    this.getNotes();
  }

  loadImage(url) {
    this.selectedImageURL = url;

    if (this.loadedImages.indexOf(url) > -1) {
      // do nothing its been loaded before
    } else {
      this.imageLoading = true;
    }

    this.displayImageModal = true;
  }

  onImageLoad(selectedImageURL) {
    this.imageLoading = false;
    this.loadedImages.push(selectedImageURL);
  }

  onImageError() {
    console.log('Error loading image');
  }
}
